import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITranslationsKeyMap } from '@modules/i18n/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IBackendTranslationsResponse,
} from '../types';
import {
  BACKEND_TRANSLATIONS_URL,
  TRANSLATE_MANAGER_BACKEND_TRANSLATIONS_QUERY_KEY,
  TRANSLATE_MANAGER_PERMISSIONS,
} from '../constants';
import { prepareBackendTranslations } from './utils';

export default function useBackendTranslationsQuery(): IContextQueryResult<IBackendTranslationsResponse, Error, ITranslationsKeyMap> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IBackendTranslationsResponse, Error, ITranslationsKeyMap>({
    queryKey: [TRANSLATE_MANAGER_BACKEND_TRANSLATIONS_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet(BACKEND_TRANSLATIONS_URL, {
      signal,
      permission: TRANSLATE_MANAGER_PERMISSIONS.TRANSLATEMANAGER_EDIT,
    }),
    select: (res) => prepareBackendTranslations(JSON.parse(res.server_locales)),
  });
}
